export default __webpack_public_path__ + "static/media/ncs-logo.2feac216.svg";